const prefix = '/audit_missions'

export const AUDIT_MISSION_SHOW_URL = (id) => `${prefix}/${id}`
export const AUDIT_MISSION_EDIT_URL = (id) => `${prefix}/${id}/edit`
export const AUDIT_MISSION_CREATE_URL = () => `${prefix}/new`
export const AUDIT_MISSION_INDEX_URL = () => `${prefix}`
